import { render, staticRenderFns } from "./coverImg.vue?vue&type=template&id=7fdf1591&scoped=true"
import script from "./coverImg.vue?vue&type=script&lang=js"
export * from "./coverImg.vue?vue&type=script&lang=js"
import style0 from "./coverImg.vue?vue&type=style&index=0&id=7fdf1591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf1591",
  null
  
)

export default component.exports